import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSocket } from '@/realtime/socketContext';
import { toast } from '@/store/ui';

export function useStartCall(onStarted?: () => void) {
  const { socket, connected } = useSocket();
  const navigate = useNavigate();
  const [starting, setStarting] = useState(false);

  const startCall = useCallback(
    (channelId: string | undefined, options?: { video?: boolean }) => {
      if (!channelId || starting) return;
      if (!socket || !connected) {
        toast.error('Call unavailable', 'Realtime is reconnecting. Try again in a moment.');
        return;
      }

      setStarting(true);
      const timeout = window.setTimeout(() => {
        setStarting(false);
        toast.error(
          'Call not started',
          'The server did not answer. Check your connection and retry.',
        );
      }, 10_000);

      socket.emit('call:start', { channelId }, (result) => {
        window.clearTimeout(timeout);
        setStarting(false);
        if (!result.ok || !result.call) {
          toast.error('Call not started', result.error ?? 'Try again.');
          return;
        }
        onStarted?.();
        navigate(`/call/${result.call.id}${options?.video ? '?video=1' : ''}`);
      });
    },
    [connected, navigate, onStarted, socket, starting],
  );

  return { startCall, starting, connected };
}
